import React from 'react';

/* ── FieldCell: unified grid row for both read-only and edit modes ── */
export const FieldCell = ({ label, required, value, editMode, error, children }) => (
  <div className="grid grid-cols-[160px_1fr] gap-x-3 items-start py-1.5" data-testid={`field-${label.toLowerCase().replace(/[\s()/]/g, '-')}`}>
    <span className="text-xs text-slate-400 pt-2">
      {label}{editMode && required ? <span className="text-red-500 ml-0.5">*</span> : null}
    </span>
    {editMode ? (
      <div>
        {children}
        {error && <p className="text-xs text-red-500 mt-1">{error}</p>}
      </div>
    ) : (
      <span className="text-sm text-slate-800 font-medium break-words pt-1">{value || <span className="text-slate-300">-</span>}</span>
    )}
  </div>
);
